import React from 'react'
import { Checkbox, Table } from 'antd'
import { SearchRequest } from '../../../../services/api/interfaces/ApiRequest'
import { BaseListComponentProps, ListComponent } from '../../../BaseComponent'
import { integrationNetworkConnect, integrationNetworkDisconnect } from '../../../../services/integration'


type IntegrationListProps = BaseListComponentProps & {
  integrations: any,
  pagination: any,
  loading: boolean,
  searchOptions: any,
  network_uuid: string,
  loadIntegrations: (args: SearchRequest) => void,
  requestIntegrationNetworkListSimple: (args: any) => void,
}

export default class IntegrationListOnNetwork extends ListComponent<IntegrationListProps> {

  static defaultProps = {
    loading: false
  }

  state = {
    removed: [] as string[],
    connectedIntegrations : [] as any[]
  }

  tableColumns = [
    {
      title: 'Connected',
      dataIndex: 'main',
      key: 'connected',
      render: (text: string, record: any) => {
        return (
          <Checkbox checked={this.isConnected(record.uuid)} onChange={(e) => this.connectOrDisconnect(record)}/>
        )
      }
    },
    {
      title: 'UUID',
      dataIndex: 'uuid',
      key: 'uuid'
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      responsive: ['md'] as any
    },
    {
      title: 'Location',
      dataIndex: ['branch', 'name'],
      key: 'branch',
      responsive: ['md'] as any
    }
    
    
  ] as any

  protected async load() {
    

    
    const shelter = await this.props.requestIntegrationNetworkListSimple({
      "fields" :  [
        "uuid",
        "shelter_id",
        "partner_key"
      ],
      "filters" : {
          "uuid" : this.props.network_uuid
      }
     })

    const temp = await this.props.requestIntegrationNetworkListSimple({
      "fields" :  [
        "uuid",
        "connections.integration.uuid",
        "connections.integration.description",
        "shelter_id"
      ],
      "filters" : {
          "uuid" : this.props.network_uuid
      }
     })

     const result = (temp as any).data?.data?.result ? (temp as any).data?.data?.result[0] : null;
     const shelter_result = (shelter as any).data?.data?.result ? (shelter as any).data?.data?.result[0] : null;

     const params = {
      search: {
        deleted: false,
        active: true,
        branch: {
          with: {
            deleted: false
          }
        },
        shelter_id:shelter_result?.shelter_id,
        partner_key:shelter_result?.partner_key
      },
      options: {
        sort: ['-last_sync'],
        _force_ids: true
      }
    }


    this.props.loadIntegrations(params)

     this.setState({connectedIntegrations:result?.connections})
  }

  connectOrDisconnect(integration){
    let arr = this.state.connectedIntegrations ? this.state.connectedIntegrations : [];

    if(this.isConnected(integration.uuid)){
      for(let i =0; i < this.state.connectedIntegrations?.length; i++){
        if(this.state.connectedIntegrations[i]?.integration.uuid === integration.uuid){
          arr.splice(i,1);
        }
      }
      integrationNetworkDisconnect({
        "network_uuid" : this.props.network_uuid,
        "integration_uuid" : integration.uuid
      })
    }else{
      (arr as any[]).push({
        integration:{
          uuid:integration.uuid
        }
      })
      
      integrationNetworkConnect({
        "network_uuid" : this.props.network_uuid,
        "integration_uuid" : integration.uuid
      })
    }
    this.setState({connectedIntegrations: arr})
  }

  isConnected(integration_uuid){
    for(let i =0; i < this.state.connectedIntegrations?.length; i++){
      if(this.state.connectedIntegrations[i]?.integration.uuid === integration_uuid){
        return true;
      }
    }
    return false;
  }

  render() {
    const { loading, pagination, integrations, loadIntegrations  } = this.props
    const { removed } = this.state

    let paginationOptions = {}
    if (pagination) {
      paginationOptions = {
        total: pagination.count,
        pageSize: pagination.limit,
        current: pagination.page
      }
    }

    return (
      <Table
        loading={loading}
        rowKey='uuid'
        columns={this.tableColumns}
        pagination={paginationOptions}
        dataSource={integrations?.filter(v => !removed.includes(v.uuid))}
        onChange={(pagination: any, filters: any, sorter: any) => this.handleTableChange(pagination, sorter, loadIntegrations)}
      />
    )
  }
}
